import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField
} from 'react-admin';

// own ui
import CustomFilterTextActive from '../../ui/custom-filter-text-active';
import CategoryTerroirsExporter from '../../exporter/category-terroirs-exporter';

const CategoryTerroirsList = (props) => (
    <List
      title="Categorias Terroirs" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterTextActive /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ CategoryTerroirsExporter } >
        <Datagrid>
          <TextField source="id" sortable={true} />
          <TextField source="name.pt_br" label="Nome" sortable={false} />
          <BooleanField source="active" label="Ativo" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default CategoryTerroirsList;
